/************************** Start - Diamond Carat Filter **************************/
var default_min_carat = 0.20;
var default_max_carat = 5.00;


var carat=[];

for(i=default_min_carat;i<=default_max_carat;i=i+0.01)
{
  var dec=i.toFixed(2);
  carat.push(dec);
}
// for(i=1;i<=2;i=i+0.25)
// {
//   var dec=i.toFixed(2);
//   carat.push(dec);
// }
// for(i=2;i<=default_max_carat;i=i+0.50)
// {
//   var dec=i.toFixed(2);
//   carat.push(dec);
// }


function getClosestNum(num, ar)
{
  //console.log(ar);
  var i = 0, closest, closestDiff, currentDiff;
  if(ar.length)
  {
    closest = ar[0];
    for(i;i<ar.length;i++)
    {           
      closestDiff = Math.abs(num - closest);
      currentDiff = Math.abs(num - ar[i]);
      if(currentDiff < closestDiff)
      {
        closest = ar[i];
      }
      closestDiff = null;
      currentDiff = null;
    }
    //returns first element that is closest to number
    return closest;
  }
  //no length
  return false;
}
  function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function get_index(value,array){
  
  var pos=0
  for (i=0;i<array.length;i++) {
    if(array[i]==value) {
      pos = i;
      break;
    }
  }
  
  return pos;

}
	
/* carat fiter start*/
function carat_slider_render(start,end,option){
    var start2=getClosestNum(start,carat);
	var end2=getClosestNum(end,carat);
	var start1=get_index(start2,carat); 
	var start11=get_index(start,carat);
	var end11=get_index(end,carat);
	var end1=get_index(end2,carat);
    var settingSelected=jQuery("#setting").val();
  var min_setting = 0//JSON.parse(localStorage.getItem("setting"))[0].minimum_carat_total_weight
    var max_setting =10// JSON.parse(localStorage.getItem("setting"))[0].maximum_carat_total_weight
  if(settingSelected == 1 && localStorage.getItem("setting") ){
    var min_setting = JSON.parse(localStorage.getItem("setting"))[0].minimum_carat_total_weight
    var max_setting = JSON.parse(localStorage.getItem("setting"))[0].maximum_carat_total_weight
  }
  	
  		jQuery("#carat-slider").slider({
			range: true,
			min: 0,
			max: carat.length-1,
			values: [ start1,end1 ],
			slide: function( event, ui ) {
				if ((ui.values[0] > ui.values[1])) { 
	                return false; 
	            }
              //disable min max slider if setting selected
          
            if(settingSelected == 1 && (parseFloat(min_setting)  > parseFloat(carat[parseInt(ui.values[0])]) || parseFloat(max_setting) < parseFloat(carat[parseInt(ui.values[1])]) )){
               return false; 
            }
				
				$("#carat_from").val(parseFloat(carat[parseInt(ui.values[0])]).toFixed(2)+' ct.');
				$('#carat_left_hidden').val(carat[parseInt(ui.values[0])]);
				$('#carat_to').val(parseFloat(carat[parseInt(ui.values[1])]).toFixed(2)+' ct.');
				$('#carat_right_hidden').val(carat[parseInt(ui.values[1])]);
			},
			change: function(event, ui) {
				if ((ui.values[0] > ui.values[1])) { 
	                return false; 
	            }
				/* $("#carat_from").val(carat[parseInt(ui.values[0])]+' ct.');
				$('#carat_left_hidden').val(carat[parseInt(ui.values[0])]);
				$('#carat_to').val(carat[parseInt(ui.values[1])]+' ct.');
				$('#carat_right_hidden').val(carat[parseInt(ui.values[1])]); */
			
              if(option==true) {	
				   	jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
                    if($("#check_reset").val() !=1) {
                        ajaxDataCall();
                    }                   	
              }
			}
			 
		});
  
		 $("#carat_from").val(parseFloat(start).toFixed(2)+' ct.');
		 $("#carat_to").val(parseFloat(end).toFixed(2)+' ct.');
		 $('#carat_left_hidden').val(start);
		 $('#carat_right_hidden').val(end);	
}


function replace_carat_from(){

  var min_carat_value = default_min_carat;
  var settingSelected=jQuery("#setting").val();

  
  if(jQuery('#carat_from').val()==''){
    var value = parseFloat(jQuery('#carat_left_hidden').val()).toFixed(2); 
    jQuery('#carat_from').val(parseFloat(value).toFixed(2)+' ct.');
    return false;
  } else {
    var hidden_carat_value = parseFloat($('#carat_left_hidden').val()).toFixed(2); 
  	var carat_value= parseFloat(jQuery('#carat_from').val()).toFixed(2); 
  }
  //alert(hidden_carat_value +'-'+carat_value);
//   var value = carat_value.replace(/ct\./g, '');
//   carat_value1_comma = value.replace(/[^0-9\,.]+/g, '');  
//   value = carat_value1_comma.replace(',', '.'); 
  
   var value = carat_value;
  var carat_value1_comma = value;  
  value = carat_value1_comma; 

  var value1=parseFloat($('#carat_to').val());
  
  /*if(value == value1){ 
    //alert('Carat from value should be less than carat to value'); 
    var value = parseFloat(jQuery('#carat_left_hidden').val()); 
    jQuery('#carat_from').val((value.toFixed(2))+' ct.');
    return false;
  } else */
   if(isNaN(value)!=false){
     var value = parseFloat(default_min_carat).toFixed(2);
     //alert("Please enter value in number");
     jQuery('#carat_from').val(value+' ct.');
  }
  else if(value > value1){
    //alert('Carat from value should be less than carat to value'); 
    $('#carat_from').val(parseFloat(hidden_carat_value).toFixed(2)+' ct.');
    return false;
  }
  else if(carat_value < min_carat_value){
	// alert('Carat from value cannot be less than '+min_carat_value+' ct.'); 
    $('#carat_from').val((parseFloat(min_carat_value).toFixed(2))+" ct.");
    carat_slider_render(min_carat_value,value1,true);
    return false;
  }
  else if(settingSelected == 1 && (hidden_carat_value > carat_value)){
     //alert('selected setting can match with diamond greater than '+hidden_carat_value);
     jQuery('#carat_from').val(hidden_carat_value+" ct.");   
    return false; 
   }
  $('#carat_left_hidden').val(value);
  $('#carat_right_hidden').val(value1);

  carat_slider_render(value,value1,true);

}

function replace_carat_to(){
  var max_carat_value = parseFloat(default_max_carat).toFixed(2);
  var settingSelected=jQuery("#setting").val();
  var setting_max_carat = 0 ;
if(settingSelected == 1){
 	setting_max_carat = JSON.parse(localStorage.getItem('setting'))[0].maximum_carat_total_weight
  }
  if(jQuery('#carat_to').val()==''){
    var value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2); 
    jQuery('#carat_to').val(parseFloat(value).toFixed(2)+' ct.');
    return false;
  } else {
    var hidden_carat_value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2); 
  	var carat_value= parseFloat(jQuery('#carat_to').val()).toFixed(2); 
  }

//   value = carat_value.replace(/ct\./g, '');
//   carat_value1_comma = value.replace(/[^0-9\.,]+/g, '');   
//   value = carat_value1_comma.replace(',', '.'); 
  
  value = carat_value;
  var carat_value1_comma = value;   
  value = carat_value1_comma; 

  var value1=parseFloat($('#carat_from').val());
	  

  /*if(value == value1){ 
    //alert('Carat to value should be greater than carat from value'); 
    var value = parseFloat(jQuery('#carat_right_hidden').val()); 
    jQuery('#carat_to').val((value.toFixed(2))+' ct.');
    return false;
  } else */ 
  if(isNaN(value)!=false){
     var value = parseFloat(default_max_carat).toFixed(2);
     alert("Please enter value in number");
     jQuery('#carat_to').val(value+' ct.');
  }
   else if(parseFloat(value) > parseFloat(max_carat_value))
  {
//     alert(value +'-'+max_carat_value);
	 //alert('Carat to value cannot be greater than '+max_carat_value+' ct.'); 
     jQuery('#carat_to').val(hidden_carat_value+" ct.");   
    return false; 
  }
  else if(value1 > value){ 
    //alert('Carat to value should be greater than carat from value');  
    $('#carat_to').val(hidden_carat_value+' ct.');
    return false;
  }
//   else if(value > max_carat_value)
//   {
//     $('#carat_to').val((max_carat_value.toFixed(2))+" Ct.");
//     carat_slider_render(value1,max_carat_value,true);
//     return false;
//   }
  
//    else if(value < max_carat_value)
//   {
// 	 alert('Carat from value should be less than carat from value'); 
//      jQuery('#carat_to').val(hidden_carat_value+" Ct.");   
//     return false; 
//   }

  else if(settingSelected == 1 && (parseFloat(setting_max_carat) < carat_value)){
     //alert('Selected setting can match with diamond less than or equal '+setting_max_carat);
     jQuery('#carat_to').val(setting_max_carat+" ct.");   
    return false; 
   }
  
  
  $('#carat_right_hidden').val(value);
  $('#carat_left_hidden').val(value1);
  
  carat_slider_render(value1,value,true);
}

/************************** End - Diamond Carat Filter **************************/


/************************** Start - Diamond Cut Filter **************************/
var min_cut = jQuery( "#cut-min-value" ).val();
var max_cut = jQuery( "#cut-max-value" ).val();
function cut_slider_render(start,end,option){ 
	jQuery("#cut-slider").slider({
			range: true,
			min: 0,
			max: 4,
			values: [ start,end ],
			slide: function( event, ui ) {
           //  alert(1);
              if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
	                return false; 
	          }
              jQuery('ul#cut_list li:nth-child('+ui.values[0]+')').addClass('focus');
	          jQuery('ul#cut_list li:nth-child('+(ui.values[1]+1)+')').addClass('focus');
	          for(var i=(ui.values[0]+1);i<(ui.values[1]+1);i++)
	          {
	        	  jQuery('ul#cut_list li:nth-child('+ i +')').removeClass('focus');  
	          }
              jQuery( "#cut-min-value" ).val(ui.values[0]);
			  jQuery( "#cut-max-value" ).val(ui.values[1]);
			},
			change: function(event, ui) {
              //  alert(2);
              	jQuery('#page_no').val(1);
				jQuery('#pagination').val('');
              	if($("#check_reset").val() !=1) {
                   ajaxDataCall();
            	}  
            }
	});
}
/************************** End - Diamond Cut Filter **************************/

/************************** Start - Diamond Color Filter **************************/
var min_color = jQuery( "#color-min-value" ).val();
var max_color = jQuery( "#color-max-value" ).val();
function color_slider_render(start,end,option){
	jQuery("#color-slider").slider({
      	range: true,
		min: 0,
		max: 7,
      
		values: [ start,end ],
		slide: function( event, ui ) {
          if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
	          return false; 
	      }
          jQuery('ul#color_list li:nth-child('+ui.values[0]+')').addClass('focus');
	      jQuery('ul#color_list li:nth-child('+(ui.values[1]+1)+')').addClass('focus');
	      for(var i=(ui.values[0]+1);i<(ui.values[1]+1);i++)
	      {
	          jQuery('ul#color_list li:nth-child('+ i +')').removeClass('focus');  
	      }
          jQuery( "#color-min-value" ).val(ui.values[0]);
		  jQuery( "#color-max-value" ).val(ui.values[1]);
	    },
		change: function(event, ui) {
          	jQuery('#page_no').val(1);
			jQuery('#pagination').val('');
            if($("#check_reset").val() !=1) {
                   ajaxDataCall();
            	} 
        }
    });
}
/************************** End - Diamond Carat Filter **************************/


/************************** Start - Diamond clarity Filter **************************/
var min_clarity = jQuery( "#clarity-min-value" ).val();
var max_clarity = jQuery( "#clarity-max-value" ).val();
function clarity_slider_render(start,end,option){
	jQuery("#clarity-slider").slider({
      	range: true,
		min: 0,
		max: 8,
		values: [ start,end ],
		slide: function( event, ui ) {
          if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
	          return false; 
	      }
          jQuery('ul#clarity_list li:nth-child('+ui.values[0]+')').addClass('focus');
	      jQuery('ul#clarity_list li:nth-child('+(ui.values[1]+1)+')').addClass('focus');
	      for(var i=(ui.values[0]+1);i<(ui.values[1]+1);i++)
	      {
	          jQuery('ul#clarity_list li:nth-child('+ i +')').removeClass('focus');  
	      }
          jQuery( "#clarity-min-value" ).val(ui.values[0]);
		  jQuery( "#clarity-max-value" ).val(ui.values[1]);
	    },
		change: function(event, ui) {
          	jQuery('#page_no').val(1);
			jQuery('#pagination').val('');
           	if($("#check_reset").val() !=1) {
                   ajaxDataCall();
            	} 
        }
    });
}
/************************** End - Diamond clarity Filter **************************/

/************************** Start - Diamond polish Filter **************************/
var min_polish = jQuery( "#min_polish" ).val();
var max_polish = jQuery( "#max_polish" ).val();
function polish_slider_render(start,end,option){
	jQuery("#polish-slider").slider({
      	range: true,
		min: 0,
		max: 3,
		values: [ start,end ],
		slide: function( event, ui ) {
          if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
	          return false; 
	      }
          jQuery('ul#polish_list li:nth-child('+ui.values[0]+')').addClass('focus');
	      jQuery('ul#polish_list li:nth-child('+(ui.values[1]+1)+')').addClass('focus');
	      for(var i=(ui.values[0]+1);i<(ui.values[1]+1);i++)
	      {
	          jQuery('ul#polish_list li:nth-child('+ i +')').removeClass('focus');  
	      }
          jQuery( "#min_polish" ).val(ui.values[0]);
		  jQuery( "#max_polish" ).val(ui.values[1]);
	    },
		change: function(event, ui) {
          	jQuery('#page_no').val(1);
			jQuery('#pagination').val('');
           	if($("#check_reset").val() !=1) {
                   ajaxDataCall();
            	} 
        }
    });
}
/************************** End - Diamond polish Filter **************************/

/************************** Start - Diamond Symmetry Filter **************************/
var min_symmetry = jQuery( "#min_symmetry" ).val();
var max_symmetry = jQuery( "#max_symmetry" ).val();
function symmetry_slider_render(start,end,option){
	jQuery("#symmetry-slider").slider({
      	range: true,
		min: 0,
		max: 3,
		values: [ start,end ],
		slide: function( event, ui ) {
          if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
	          return false; 
	      }
          jQuery('ul#symmetry_list li:nth-child('+ui.values[0]+')').addClass('focus');
	      jQuery('ul#symmetry_list li:nth-child('+(ui.values[1]+1)+')').addClass('focus');
	      for(var i=(ui.values[0]+1);i<(ui.values[1]+1);i++)
	      {
	          jQuery('ul#symmetry_list li:nth-child('+ i +')').removeClass('focus');  
	      }
          jQuery( "#min_symmetry" ).val(ui.values[0]);
		  jQuery( "#max_symmetry" ).val(ui.values[1]);
	    },
		change: function(event, ui) {
          	jQuery('#page_no').val(1);
			jQuery('#pagination').val('');
            if($("#check_reset").val() !=1) {
                   ajaxDataCall();
            	} 
        }
    });
}
/************************** End - Diamond Symmetry Filter **************************/

/************************** Start - Diamond fluorescence Filter **************************/
var min_fluorescence = jQuery( "#min_fluorescence" ).val();
var max_fluorescence = jQuery( "#max_fluorescence" ).val();
function fluorescence_slider_render(start,end,option){
	jQuery("#fluorescence-slider").slider({
      	range: true,
		min: 0,
		max: 4,
		values: [ start,end ],
		slide: function( event, ui ) {
          if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
	          return false; 
	      }
          jQuery('ul#fluorescence_list li:nth-child('+ui.values[0]+')').addClass('focus');
	      jQuery('ul#fluorescence_list li:nth-child('+(ui.values[1]+1)+')').addClass('focus');
          for(var i=(ui.values[0]+1);i<(ui.values[1]+1);i++)
	      {
	          jQuery('ul#fluorescence_list li:nth-child('+ i +')').removeClass('focus');  
	      }
          jQuery( "#min_fluorescence" ).val(ui.values[0]);
		  jQuery( "#max_fluorescence" ).val(ui.values[1]);
	    },
		change: function(event, ui) {
          	jQuery('#page_no').val(1);
			jQuery('#pagination').val('');
           	if($("#check_reset").val() !=1) {
                  ajaxDataCall();
            	} 
        }
    });
}
/************************** End - Diamond fluorescence Filter **************************/

/************************** Start - Diamond Price Filter **************************/

var default_min_price = Math.round(200 * Shopify.currency.rate);	
var default_max_price = Math.round(200000 * Shopify.currency.rate);
var searchParams = new URLSearchParams(window.top.location.search); 
   if(searchParams.has('currency')){
     var current_url  = window.top.location.href;
     var new_url = current_url.substring(0, current_url.indexOf('?'));
      localStorage.setItem("white_dia_shape",'');
      localStorage.setItem("white_min_price", default_min_price);
      localStorage.setItem("white_max_price", default_max_price);
      localStorage.setItem("white_min_carat", default_min_carat);
      localStorage.setItem("white_max_carat", default_max_carat);
      localStorage.setItem("white_min_cut",'0');
      localStorage.setItem("white_max_cut",'4');
      localStorage.setItem("white_min_color",'0');
      localStorage.setItem("white_max_color",'7');
      localStorage.setItem("white_min_clarity", "0");
      localStorage.setItem("white_max_clarity", "8");
      localStorage.setItem("white_min_polish",'0');
      localStorage.setItem("white_max_polish",'3');
      localStorage.setItem("white_min_symmetry",'0');
      localStorage.setItem("white_max_symmetry",'3');
      localStorage.setItem("white_min_flour",'0');
      localStorage.setItem("white_max_flour",'4');
      localStorage.setItem("white_min_depth",'45');
      localStorage.setItem("white_max_depth",'85');
      localStorage.setItem("white_min_table",'45');
      localStorage.setItem("white_max_table",'85');
      localStorage.setItem("white_lab",'');
      localStorage.setItem("white_compare_ids",'');
     history.pushState({}, null, new_url);
   }
var price = [];

for (var i = parseFloat(default_min_price) ; i < 50000; i = i+100) {
  price.push(i);
}
for (var i = 50000 ; i < parseFloat(default_max_price); i = i+1000) {
  price.push(i);
}
price.push(parseFloat(default_max_price));
function addCommas(price)
{
        price += '';
		x = price.split('.');
        x1 = x[0];
        x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
		return x1 + x2;

}
function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

function price_slider_render(start,end,option){	
	//resetpriceCalibration();
    var start2=getClosestNum(start,price);
    var end2=getClosestNum(end,price);
    var start1=get_priceindex(start2); 
    var start11=get_priceindex(start);
    var end11=get_priceindex(end);
    var end1=get_priceindex(end2); 
    
        jQuery("#price-slider").slider({
            range: true,
            min: 0,
            max: price.length-1,
            values: [ start1,end1 ],
            step:0.1,
            slide: function( event, ui ) { 
                if ((ui.values[0]) > (ui.values[1])) { 
                    return false; 
                }
             jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
             jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
             jQuery('#price_from').val(currency_symbol+""+addCommas(price[parseInt(ui.values[0])].toFixed(2)));
             jQuery('#price_to').val(currency_symbol+""+addCommas(price[parseInt(ui.values[1])].toFixed(2)));
             
            },
            change: function(event, ui) {
                           
             //if(option==true) {
                jQuery('#page_no').val(1);
                jQuery('#pagination').val('');
              	if($("#check_reset").val() !=1) {
                   ajaxDataCall();
            	} 
	 			//}
              slide = '';
            }
             
        });
          var start_num = parseInt(start);
          var end_num = parseInt(end);
	
          var start_dec= start_num.toFixed(2);
          var end_dec= end_num.toFixed(2);
         jQuery('#price_left_hidden').val(start_dec);
         jQuery('#price_right_hidden').val(end_dec);
  		 jQuery('#price_from').val(currency_symbol+""+addCommas(start_dec));  
  		 jQuery('#price_to').val(currency_symbol+""+addCommas(end_dec));
}

function get_priceindex(value){
    var pos=0
    for (i=0;i<price.length;i++) {
        if(price[i]==value) {
            pos = i;
            break;
        }
    }
    return pos;
    
}


/*************************** Start - price validation ***************************/

$("#price_to").keypress(function (e) {
        //if the letter is not digit then display error and don't type anything
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
            return false;
        }
    });

    $("#price_from").keypress(function (e) {
        //if the letter is not digit then display error and don't type anything
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
            return false;
        }
    });

/*
jQuery('#price_to').keypress(function(event) {
  if ((event.which != 46 || jQuery(this).val().indexOf('.') != -1) &&
    ((event.which < 48 || event.which > 57) &&
      (event.which != 0 && event.which != 8))) 
  {
    event.preventDefault();
  }
  var text = $(this).val();

  if ((text.indexOf('.') != -1) &&
    (text.substring(text.indexOf('.')).length > 2) &&
    (event.which != 0 && event.which != 8) &&
    (jQuery(this)[0].selectionStart >= text.length - 2)) 
  {
    event.preventDefault();
  }
});
*/

/*************************** End - price validation ***************************/

	

    function replace_price_to(){
		var get_default_min = default_min_price;
		var get_default_max = default_max_price;
// 		if(store_current_currency != 'USD'){
// 			get_default_min = Math.floor(Currency.convert(parseInt(default_min_price),'USD',store_current_currency));
// 			get_default_max = Math.ceil(Currency.convert(parseInt(default_max_price),'USD',store_current_currency));
//         }
        if(jQuery('#price_to').val()==''){
            var value = parseFloat(jQuery('#price_right_hidden').val()); 
            jQuery('#price_to').val(currency_symbol+""+addCommas(value.toFixed(2)));
          	return false;
        } else {
            var value =jQuery('#price_to').val();
        }
     
        var value1=jQuery('#price_from').val();
		//alert(value1//);//
        value=value.replace(/[^\d\.]/g, '');
        value1=value1.replace(/[^\d\.]/g, '');

        value=parseInt(value);
        value1=parseInt(value1);
      
      // alert(jQuery('#price_to').val());
      if(isNaN(value)!=false){
           var value = get_default_max;
           //alert("Please enter value in number");
           jQuery('#price_to').val(currency_symbol+addCommas(value));
        }
      else if(value > get_default_max){         
           //alert('Price from should be less than '+currency_symbol+addCommas(get_default_max));
          var valLimit = parseFloat(jQuery('#price_right_hidden').val());
          jQuery('#price_to').val(currency_symbol+""+addCommas(valLimit.toFixed(2)));
          return false;
        } else if(value1> value){ 
            //alert('Price from should be less than '+currency_symbol+'200');
          //	alert('Price to value should be greater than price from value');  
            var valLimit = parseFloat(jQuery('#price_right_hidden').val());
          	jQuery('#price_to').val(currency_symbol+""+addCommas(valLimit.toFixed(2)));
            return false;
        }else if(value1==''){
            jQuery('#price_from').val(value1);
        }
     
        jQuery('#price_right_hidden').val(value.toFixed(2));
        jQuery('#price_left_hidden').val(value1.toFixed(2));
        price_slider_render(value1,value,true);
    
    }

    function replace_price_from(){
		var get_default_min = default_min_price;
		var get_default_max = default_max_price;
// 		if(store_current_currency != 'USD'){
// 			get_default_min = Math.floor(Currency.convert(parseInt(default_min_price),'USD',store_current_currency));
// 			get_default_max = Math.ceil(Currency.convert(parseInt(default_max_price),'USD',store_current_currency));
//         }
      	if(jQuery('#price_from').val()==''){
         // alert(1);
            var value = parseFloat(jQuery('#price_left_hidden').val()); 
            jQuery('#price_from').val(currency_symbol+""+(value.toFixed(2)));
           	return false;
        } else{
            var value =jQuery('#price_from').val();
        }
        var value1=jQuery('#price_to').val();

        value=value.replace(/[^\d\.]/g, '');
        value1=value1.replace(/[^\d\.]/g, '');
        value=parseInt(value);
        value1=parseInt(value1);
      
     //  alert(value+'--'+value1);
        if(isNaN(value)!=false){
           var value = get_default_min;
           //alert("Please enter value in number");
           jQuery('#price_from').val(currency_symbol+addCommas(value));
        }
       else if(value < get_default_min){        
          //alert('Price from should be greater than '+currency_symbol+addCommas(get_default_min));
          var valLimit = parseFloat(jQuery('#price_left_hidden').val()); 
          jQuery('#price_from').val(currency_symbol+""+addCommas(valLimit.toFixed(2)));
          return false;
        } else if(value > value1){
          	//alert("Price from should be less than "+currency_symbol+"2,000,00");
          //	alert('Price from value should be less than price to value'); 
          	price_slider_render(price[0],value1,true);
          	return false;
        }
      	
        jQuery('#price_left_hidden').val(value.toFixed(2));
        jQuery('#price_right_hidden').val(value1.toFixed(2));
        price_slider_render(value,value1,true);
    
    }
/************************** End - Diamond Price Filter **************************/

/************************** Start - Diamond sorting Filter **************************/
function sorting_data(sorting,className){ 
	 
	var sortorder='';
  	var clas = className;

    jQuery('.datagrid-sort').each(function(){	
  	 	if(jQuery(this).hasClass('icon-up-arrow')){
            jQuery(this).removeClass('icon-up-arrow').addClass('icon-down-arrow');  
        }      
    });
  
  	if((mySelection[1]==sorting) && (mySelection[2]=='ASC')){
		sortorder='DESC';
      	jQuery(clas).find('i').removeClass('icon-down-arrow').addClass('icon-up-arrow');	
  	}else{
  		sortorder='ASC';
      	jQuery(clas).find('i').addClass('icon-down-arrow').removeClass('icon-up-arrow');	
    }  
  	jQuery('#sort_call').val(sorting);
  	jQuery('#sort_dir').val(sortorder);
  
  	
  
  	mySelection[1]=jQuery('#sort_call').val();
	mySelection[2]=jQuery('#sort_dir').val();
  	jQuery('#page_no').val(1);
	jQuery('#pagination').val('');
    ajaxDataCall();
 }
/************************** End - Diamond sorting Filter **************************/

/************************** Start - Diamond depth Filter **************************/
var depth=[];

for(i=45;i<85;i=i+0.10)
{
  var dec=i.toFixed(2);
  depth.push(dec);
}
function depth_slider_render(start,end,option){ 
  //console.log(start+"--"+end+"--"+option);
    var start2=getClosestNum(start,depth);
	var end2=getClosestNum(end,depth);
	var start1=get_index(start2,depth); 
	var start11=get_index(start,depth);
	var end11=get_index(end,depth);
	var end1=get_index(end2,depth);
  //console.log(start+"--"+end+"--"+start1+"--"+end1+"--"+start2+"--"+end2+"--"+start11+"--"+end11);
		jQuery("#depth-slider").slider({
			range: true,
			min: 0,
			max: depth.length-1,
			values: [ start1,end1 ],
			slide: function( event, ui ) {
				//if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
              		if ((ui.values[0] > ui.values[1])) { 
	                return false; 
	            }
				
				$("#depth_from").val(depth[parseInt(ui.values[0])]+'%');
				$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
				$('#depth_to').val(depth[parseInt(ui.values[1])]+'%');
				$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);
			},
			change: function(event, ui) {
				//if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) { 
          		if ((ui.values[0] > ui.values[1])) { 
	                return false; 
	            }
				$("#depth_from").val(depth[parseInt(ui.values[0])]+'%');
				$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
				$('#depth_to').val(depth[parseInt(ui.values[1])]+'%');
				$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);
			
              if(option==true) {	
				   	jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
                   	if($("#check_reset").val() !=1) {
                   ajaxDataCall();
            	} 
              }
			}
			 
		});
  
  		var Start_limit = parseFloat(start);  	
  		var End_limit = parseFloat(end);
  
		 $("#depth_from").val(Start_limit.toFixed(2)+'%');
		 $("#depth_to").val(End_limit.toFixed(2)+'%');
		 $('#depth_left_hidden').val(start);
		 $('#depth_right_hidden').val(end);
		
	
}

function replace_depth_from(){
 
  var min_depth_value = 45.00;
  
  if(jQuery('#depth_from').val()==''){
    var value = parseFloat(jQuery('#depth_left_hidden').val()); 
    jQuery('#depth_from').val((value.toFixed(2))+'%');
    return false;
  } else{
    var depth_value=parseFloat(jQuery('#depth_from').val());
    var hidden_depth_value = $('#depth_left_hidden').val();
  }
  //  alert(depth_value);
 // var value = depth_value.replace(/%\./g, '');
  // var depth_value1_comma = value.replace(/[^0-9\.,]+/g, ''); 
 // value = depth_value1_comma.replace(',', '.'); 
  var value = depth_value;
  //alert(value);
  
  var depth_value1_comma = value;   
  value = depth_value1_comma; 
  
  var value1=parseFloat($('#depth_to').val());
 // alert(value+'--'+value1);
  /* if(value == value1){ 
    alert('Depth from value should be less than depth to value'); 
    var value = parseFloat(jQuery('#depth_left_hidden').val()); 
    jQuery('#depth_from').val((value.toFixed(2))+'%');
    return false;
  } else */
  if(isNaN(value)!=false){
     var value = 45.00;
    // alert("Please enter value in number");
     jQuery('#depth_from').val(value+'%');
  }
  else if(value > value1){ 
  // alert('Depth from value should be less than depth to value'); 
    var value = parseFloat(jQuery('#depth_left_hidden').val()); 
    jQuery('#depth_from').val((value.toFixed(2))+'%');
    return false;
  }else if(depth_value < min_depth_value){
     //   alert('Depth from value should be greater than '+ min_depth_value+"%"); 
    $('#depth_from').val(min_depth_value+"%");
    depth_slider_render(min_depth_value,value1,true);
    return false;
  }

  $('#depth_left_hidden').val(value);
  $('#depth_right_hidden').val(value1);

  depth_slider_render(value,value1,true);

}

function replace_depth_to(){

  var max_depth_value = 85.00;
  
  if(jQuery('#depth_to').val()==''){
    var value = parseFloat(jQuery('#depth_right_hidden').val()); 
    jQuery('#depth_to').val((value.toFixed(2))+'%');
    return false;
  } else{
    var depth_value= parseFloat(jQuery('#depth_to').val());
    var hidden_depth_value = $('#depth_right_hidden').val();
  }

 // value = depth_value.replace(/%\./g, '');
//   var depth_value1_comma = value.replace(/[^0-9\.,]+/g, '');   
//   value = depth_value1_comma.replace(',', '.'); 
//   var value = depth_value;
  //alert(value);
//   if(isNaN(value)!=false){
//      var value = 90.00;
//    // alert(value);
//      jQuery('#depth_to').val(value+'%');
//   }
  value = depth_value;
  var depth_value1_comma = value;   
  value = depth_value1_comma; 

  var value1=parseFloat($('#depth_from').val());

  /* if(value1 == value){ 
    alert('Depth to value should be greater than depth from value'); 
    var value = parseFloat(jQuery('#depth_right_hidden').val()); 
    jQuery('#depth_to').val((value.toFixed(2))+'%');
    return false;
  } else */
   if(isNaN(value)!=false){
     var value = 85.00;
  // alert('Please enter value in number');
     jQuery('#depth_to').val(value+'%');
  }
  else if(value1> value){ 
    // alert('Depth to value should be greater than depth from value');  
    var value = parseFloat(jQuery('#depth_right_hidden').val()); 
    jQuery('#depth_to').val((value.toFixed(2))+'%');
    return false;
  }else if(value > max_depth_value)
  {
    // alert('Depth to value should be less than '+max_depth_value+"%"); 
    $('#depth_to').val(max_depth_value+"%");
    depth_slider_render(value1,max_depth_value,true);
    return false;
  }

  $('#depth_right_hidden').val(value);
  $('#depth_left_hidden').val(value1);
  
  depth_slider_render(value1,value,true);
}
/************************** End - Diamond depth Filter **************************/

/************************** Start - Diamond table Filter **************************/
var table=[];

for(i=45;i<85;i=i+0.10)
{
  var dec=i.toFixed(2);
  table.push(dec);
}
function table_slider_render(start,end,option){ 
  //console.log(start+"--"+end+"--"+option);
    var start2=getClosestNum(start,table);
	var end2=getClosestNum(end,table);
	var start1=get_index(start2,table); 
	var start11=get_index(start,table);
	var end11=get_index(end,table);
	var end1=get_index(end2,table);
  //console.log(start+"--"+end+"--"+start1+"--"+end1+"--"+start2+"--"+end2+"--"+start11+"--"+end11);
		jQuery("#table-slider").slider({
			range: true,
			min: 0,
			max: table.length-1,
			values: [ start1,end1 ],
			slide: function( event, ui ) {
				//if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) {
                if ((ui.values[0] > ui.values[1])) { 
	                return false; 
	            }
				
				$("#table_from").val(table[parseInt(ui.values[0])]+'%');
				$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
				$('#table_to').val(table[parseInt(ui.values[1])]+'%');
				$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
			},
			change: function(event, ui) {
				//if ((ui.values[0] >= ui.values[1]) || (ui.values[0] == ui.values[1])) {
                if ((ui.values[0] > ui.values[1])) { 
	                return false; 
	            }
				$("#table_from").val(table[parseInt(ui.values[0])]+'%');
				$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
				$('#table_to').val(table[parseInt(ui.values[1])]+'%');
				$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
			
              if(option==true) {	
				   	jQuery('#page_no').val(1);
					jQuery('#pagination').val('');
                   	if($("#check_reset").val() !=1) {
                   ajaxDataCall();
            	} 
              }
			}
			 
		});
  
  
    var Start_limit = parseFloat(start);  	
    var End_limit = parseFloat(end);

    $("#table_from").val(Start_limit.toFixed(2)+'%');
    $("#table_to").val(End_limit.toFixed(2)+'%');

    $('#table_left_hidden').val(start);
    $('#table_right_hidden').val(end);
		
	
}

function replace_table_from(){ 
  
  var min_table_value = 45.00;
  
  if(jQuery('#table_from').val()==''){
    var value = parseFloat(jQuery('#table_left_hidden').val()); 
    jQuery('#table_from').val((value.toFixed(2))+'%');
    return false;
  } else{
    var table_value= parseFloat(jQuery('#table_from').val());
    var hidden_table_value = $('#table_left_hidden').val();
  }
  
//   var value = table_value.replace(/%\./g, '');
//   table_value1_comma = value.replace(/[^0-9\.,]+/g, '');   
//   value = table_value1_comma.replace(',', '.'); 
  var value = table_value;
  var table_value1_comma = value;   
  value = table_value1_comma; 


  var value1=parseFloat($('#table_to').val());

  /* if(value == value1){ 
    alert('Table from value should be less than table to value'); 
    var value = parseFloat(jQuery('#table_left_hidden').val()); 
    jQuery('#table_from').val((value.toFixed(2))+'%');
    return false;
  } else */ 
   if(isNaN(value)!=false){
     var value = 45.00;
    //alert('Please enter value in number');  
     jQuery('#table_from').val(value+'%');
  }
  else if(value> value1){ 
    //alert('Table from value should be less than table to value'); 
    var value = parseFloat(jQuery('#table_left_hidden').val()); 
    jQuery('#table_from').val((value.toFixed(2))+'%');
    return false;
  }else if(table_value < min_table_value){
    // alert('Table from value should be greater than '+min_table_value+"%"); 
    $('#table_from').val(min_table_value+"%");
    table_slider_render(min_table_value,value1,true);
    return false;
  }
  
  
  $('#table_left_hidden').val(value);
  $('#table_right_hidden').val(value1);

  table_slider_render(value,value1,true);

}

function replace_table_to(){

  // var hidden_table_value = $('#table_right_hidden').val(); 
  // var table_value=$('#table_to').val();
  var max_table_value = 85.00;
    
  if(jQuery('#table_to').val()==''){
    var value = parseFloat(jQuery('#table_right_hidden').val()); 
    jQuery('#table_to').val((value.toFixed(2))+'%');
    return false;
  } else{
    var table_value= parseFloat(jQuery('#table_to').val());
    var hidden_table_value = $('#table_right_hidden').val();
  }
  
//   value = table_value.replace(/%\./g, '');
//   table_value1_comma = value.replace(/[^0-9\.,]+/g, '');   
//   value = table_value1_comma.replace(',', '.'); 
  
   value = table_value;
  var table_value1_comma = value;   
  value = table_value1_comma; 

  var value1=parseFloat($('#table_from').val());

  /* if(value == value1){ 
    alert('Table from value should be less than table to value'); 
    var value = parseFloat(jQuery('#table_right_hidden').val()); 
    jQuery('#table_to').val((value.toFixed(2))+'%');
    return false;
  } else */
  if(isNaN(value)!=false){
     var value = 85.00;
    //alert('Please enter value in number');  
     jQuery('#table_to').val(value+'%');
  }
  else if(value1> value){ 
    //alert('Table to value should be greater than table from value');  
    var value = parseFloat(jQuery('#table_right_hidden').val()); 
    jQuery('#table_to').val((value.toFixed(2))+'%');
    return false;
  } else if(value > max_table_value) {
     //alert('Table to value should be less than '+ max_table_value+"%" );
    $('#table_to').val(max_table_value+"%");
    table_slider_render(value1,max_table_value,true);
    return false;
  }

  $('#table_right_hidden').val(value);
  $('#table_left_hidden').val(value1);
  
  table_slider_render(value1,value,true);
}
/************************** End - Diamond table Filter **************************/

    function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

$(document).ready(function(){
	$('.dropdown-menu').hide();
});

$(document).mouseup(function(e) 
{
    var container = $(".dropdown-toggle");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        $('.dropdown-menu').hide();
    }
});
$(document).on('click','.dropdown-toggle',function(){
		$(this).next('.dropdown-menu').toggle();
});
function openFile(file) {
    var extension = file.substr( (file.lastIndexOf('.') +1) );
  	
    extension = extension.split("?")[0]
    switch(extension) {
        case 'jpg':
        case 'JPG':
        case 'png':
        case 'jpeg':
        case 'gif':
            return true;  // There's was a typo in the example where
        break;                         // the alert ended with pdf instead of gif.
        default:
           return false;
    }
};
